import { useInView, useReducedMotion } from "motion/react";
import { useEffect, useRef, useState } from "react";

/**
 * One-shot scenes: the server and reduced motion render the final state. On
 * the client the scene rewinds to its start while offscreen (`rewound`), then
 * plays once when it scrolls into view.
 */
export function usePlayOnce<T extends Element = HTMLDivElement>() {
	const ref = useRef<T>(null);
	const inView = useInView(ref, { once: true, margin: "0px 0px -15% 0px" });
	const reducedMotion = useReducedMotion();
	const [rewound, setRewound] = useState(false);

	useEffect(() => {
		setRewound(!reducedMotion && !inView);
	}, [reducedMotion, inView]);

	return { ref, rewound };
}
